import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogContentText,
  IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { setDescriptiveFitDetails } from 'store/actions';

const ViewDescriptiveFitDetailsModal = ({
  classes,
  descriptiveFitDetails,
  setDescriptiveFitDetails
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (descriptiveFitDetails) {
      setIsOpen(true);
    }
  }, [descriptiveFitDetails])

  const handleClose = () => {
    setIsOpen(false);
  }

  const onExited = () => {
    setDescriptiveFitDetails(null);
  }

  return (
    <Dialog onClose={handleClose} open={isOpen} maxWidth={'xl'} fullWidth={true} TransitionProps={{ onExited }}>
      <DialogTitle>
        Descriptive Fit Details
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <ClearIcon fontSize="inherit" />
      </IconButton>

      <DialogContent>
        <DialogContentText>
          <Typography style={{ whiteSpace: 'pre-wrap' }}>{descriptiveFitDetails}</Typography>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}

const styles = theme => ({
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    backgroundColor: '#ffffff'
  },
});

const mapState = state => {
  const details = state.channelWorkflowState.descriptiveFitDetails

  return {
    descriptiveFitDetails: details,
  }
};

const mapDispatch = dispatch => ({
  setDescriptiveFitDetails: (value) => dispatch(setDescriptiveFitDetails(value)),
});

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch)
)(ViewDescriptiveFitDetailsModal);